/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum AffiliateTypeEnum {
    Partner = 'partner',
    Referral = 'referral'
}

export function AffiliateTypeEnumFromJSON(json: any): AffiliateTypeEnum {
    return AffiliateTypeEnumFromJSONTyped(json, false);
}

export function AffiliateTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffiliateTypeEnum {
    return json as AffiliateTypeEnum;
}

export function AffiliateTypeEnumToJSON(value?: AffiliateTypeEnum | null): any {
    return value as any;
}

